import { FilterSelectionState } from "@/filters/selection/FilterSelectionState";
import { Degree } from "@/models/Degree";
import { SortingState } from "@/sorting/SortingState";
import { ISeoMetaDataInfo } from "../../ISeoMetaDataInfo";
import { SeoMetaDataHandler } from "../../SeoMetaDataHandler";
import { SortingOptions } from "@/sorting/SortingOptions";
import { AttendanceFilterOptionValue, FilterKey } from "@studyportals/search-filters";

export class AreaAttendanceOnline extends SeoMetaDataHandler {
	
	public async canHandle(sortState: SortingState, filterSelectionState: FilterSelectionState): Promise<boolean> {
		const metaRankSortingSelected = await this.sortingOptionSelected(SortingOptions.UNIVERSITY_META_RANKING, sortState);
		const deliveryMethodSelected = await this.singleSelectionFor(FilterKey.DELIVERY_METHOD, filterSelectionState);
		const deliveryMethod = this.getFilterOptionValueBy(FilterKey.DELIVERY_METHOD, filterSelectionState);
		const areaSelected = await this.singleSelectionFor(FilterKey.AREA, filterSelectionState);
		const countrySelected = await this.singleSelectionFor(FilterKey.COUNTRY, filterSelectionState);
		const selectedTypeCount = this.selectionTypeCount(filterSelectionState);

		return metaRankSortingSelected
			&& (deliveryMethodSelected
				&& deliveryMethod === AttendanceFilterOptionValue.ONLINE
				&& areaSelected
				&& (selectedTypeCount === 2 || (selectedTypeCount === 3 && countrySelected)));
	}

	protected selfHandle(degree: Degree, filterSelectionState: FilterSelectionState): Promise<ISeoMetaDataInfo> {
		const area = this.getFilterOptionNameBy(FilterKey.AREA, filterSelectionState);
		const country = this.getFilterOptionNameBy(FilterKey.COUNTRY, filterSelectionState);

		const seoInfo = {
			title: `Leading Online Universities in ${area} | SP Meta Ranking`,

			description:
				`Find the online universities in ${area}, ${country} with Studyportals University Meta Ranking. ` +
				`Filter, assess and find your perfect university. `
		};

		return Promise.resolve(seoInfo);
	}
}
